<template>
  <!-- 灰度配置查看升级情况 -->
  <div class="page">
    <div class="search">
      <el-form
        ref="form"
        :model="searchParams"
        label-width="auto"
        class="from"
        size="mini"
      >
        <el-form-item :label="$t('pages.equipment.text7')">
          <el-input
            v-model="searchParams.bikeCode"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text231')">
          <el-select
            v-model="searchParams.upgradeStatus"
            :placeholder="$t('public.text5')"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('omission.text5')">
          <el-date-picker
            style="width: 180px"
            v-model="searchParams.stopAt"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions0"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>

    <!-- 按钮区域 -->
    <div class="operation">
      <DiluButton
        type="search"
        size="mini"
        @click="UpgradeListInfo"
      ></DiluButton>
      <DiluButton type="reset" size="mini" @click="reset"></DiluButton>
      <DiluButton
        type="export"
        size="mini"
        @click="download"
        :title="$t('button.downloadReport')"
      ></DiluButton>
    </div>

    <!-- 表格 -->
    <DiluTable :list="list" :tableConfig="tableConfig">
      <el-table-column prop="date" label="#" width="55" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="bikeCode"
        :label="$t('pages.equipment.text7')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="upgradeStatus"
        :label="$t('pages.equipment.text231')"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.upgradeStatus == 0">{{
            $t("pages.equipment.text233")
          }}</span>
          <span v-if="scope.row.upgradeStatus == 1">{{
            $t("pages.equipment.text232")
          }}</span>
          <span v-if="scope.row.upgradeStatus == 2">{{
            $t("omission.text7")
          }}</span>
          <span v-if="scope.row.upgradeStatus == 3">{{
            $t("omission.text8")
          }}</span>
          <span v-if="scope.row.upgradeStatus == 4">{{
            $t("omission.text9")
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="hwVersion"
        :label="$t('pages.equipment.text199')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="fwVersion"
        :label="$t('pages.equipment.text201')"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="upgradeStartTime"
        :label="$t('omission.text6')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="upgradeCompleteTime"
        :label="$t('omission.text5')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="remark"
        :label="$t('omission.text10')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        :label="$t('public.text4')"
        align="center">
        <template slot-scope="scope">
          <el-button v-if="scope.row.upgradeStatus!=0" @click="restartUpgrade(scope.row)">{{ $t("omission.text81") }}</el-button>
        </template>
      </el-table-column>
    </DiluTable>
  </div>
</template>

<script>
import DiluTable from "../../../../components/pubilc/dilu-table.vue";
import DiluButton from "../../../../components/pubilc/dilu-button.vue";
import { resetDate } from "../../../../utils/util/validate";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      searchParams: {
        id: "", // id
        bikeCode: "", //车辆编码
        stopAt: "", //查询结束时间
        upgradeStatus: "", //升级状态
        remark: "", //升级结果说明
      },
      tableConfig: {
        isTree: false,
        isPage: false,
      },
      options: [
        {
          value: "0",
          label: this.$t("pages.equipment.text233"),
        },
        {
          value: "1",
          label: this.$t("pages.equipment.text232"),
        },
        {
          value: "2",
          label: this.$t("omission.text7"),
        },
        {
          value: "3",
          label: this.$t("omission.text8"),
        },
        {
          value: "4",
          label: this.$t("omission.text9"),
        },
      ],
      list: [],
    };
  },
  watch: {
    activeName: {
      handler(val) {
        if (val == "GrayscaleSituation") {
          this.searchParams.id = this.$route.query.id;
          this.UpgradeListInfo();
        }
      },
    },
  },
  components: {
    DiluTable,
    DiluButton,
  },
  props: ["activeName", "formalUpgradeInfo"],
  methods: {
    //查询
    UpgradeListInfo() {
      this.searchParams.stopAt = resetDate(this.searchParams.stopAt); // 服务结束时间
      this.request.UpgradeListInfo(this.searchParams).then((res) => {
        this.list = res.data;
        if (this.list.length>0) {
          for (var i=0; i<this.list.length; i++) {
            if (this.list[i].upgradeStartTime!=""&&this.list[i].upgradeStartTime!=null) {
              this.list[i].upgradeStartTime=this.list[i].upgradeStartTime.substring(5,this.list[i].upgradeStartTime.length);
            }
            if (this.list[i].upgradeCompleteTime!=""&&this.list[i].upgradeCompleteTime!=null) {
              this.list[i].upgradeCompleteTime=this.list[i].upgradeCompleteTime.substring(5,this.list[i].upgradeCompleteTime.length);
            } 
          }
        }
      });
    },
    //重置
    reset() {
      this.searchParams = {
        id: this.$route.query.id, // id
        bikeCode: "", //车辆编码
        stopAt: "", //查询结束时间
        upgradeStatus: "", //升级状态
      };
      this.UpgradeListInfo();
    },
    //下载报告
    download() {
      this.searchParams.stopAt = resetDate(this.searchParams.stopAt); // 服务结束时间
      let params = {
        ...this.searchParams,
        upgradeType: this.$route.query.upgradeType,
        taskType: "0",
      };
      this.request.UpgradeTaskExportBluetoothTaskInfo(params).then(() => {});
    },
    //重新升级
    restartUpgrade(e) {
      let params = {
        id: e.id,
        bikeCode: e.bikeCode
      };
      this.request.UpgradeTaskRestart(params).then(() => {
        this.reset();
      });
    },
  },
};
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
.search {
  display: flex;
  justify-content: space-between;
  margin-right: 10px;
  margin-top: 20px;
}
</style>